import { z } from 'zod';

import { IdSchema, KopecksSchema } from './common';

/**
 * «Приведи своего» (BLUEPRINT 2.2.10, Stage 11 задача 4): экран `/invite` — ссылка,
 * статус приглашённых и бонус, который спишется с ближайшего заказа.
 * Привязка (`referral.attach`) сделана в Stage 3.
 */

export const ReferralInviteeSchema = z.object({
  userId: IdSchema,
  firstName: z.string(),
  joinedAt: z.string().datetime(),
  /** Приглашённый оплатил первый заказ — бонус заработан обоими */
  paid: z.boolean(),
  paidAt: z.string().datetime().nullable(),
  /** Он в моём отряде */
  inMySquad: z.boolean(),
  /** Мой бонус за этого приглашённого уже списан с заказа */
  bonusUsed: z.boolean(),
});
export type ReferralInvitee = z.infer<typeof ReferralInviteeSchema>;

export const ReferralStatsSchema = z.object({
  link: z.string().nullable(),
  code: z.string(),
  /** Размер бонуса за одного приглашённого (`pricing.referralBonus`) */
  bonusKopecks: KopecksSchema,
  /** Сколько спишется с ближайшего заказа сезона */
  availableKopecks: KopecksSchema,
  invited: z.array(ReferralInviteeSchema),
  /** Кто привёл меня: бонус мне начисляется после моей первой оплаты */
  invitedBy: z
    .object({
      firstName: z.string(),
      earned: z.boolean(),
      bonusUsed: z.boolean(),
    })
    .nullable(),
});
export type ReferralStats = z.infer<typeof ReferralStatsSchema>;
